import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Devices from "./pages/devices";
import Landing from "./pages/landing";
import About from "./pages/about";
import Login from "./pages/login";
import DeviceDetail from "./pages/DeviceDetail";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/device/:uid" element={<DeviceDetail />} />
      </Routes>
    </Router>
  );
};

export default App;
